import React, { useEffect } from "react";
import HeroSection from "./HeroSection";
import ProductDetails from "./ProductDetails";
import Benefits from "./Benefits";
import FAQSection from "./FAQSection";

import main from "../assets/invisiblegrills/main.jpg";
import img1 from "../assets/invisiblegrills/1.jpg";
import img2 from "../assets/invisiblegrills/2.jpg";
import img3 from "../assets/invisiblegrills/3.jpg";
import Images from "./Images";
import { Helmet } from "react-helmet-async";

export default function InvisibleGrills() {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, []);

  const schemaData = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    name: "Invisible Grills in Bengaluru - ANS Safety Nets",
    url: "https://www.anssafetynets.com/invisiblegrills",
    description:
      "Secure your balconies and windows with stylish Invisible Grills by ANS Safety Nets in Bengaluru. Enjoy safety with an unobstructed view and modern design.",
    keywords: [
      "ANS Safety Nets",
      "Invisible Grills",
      "Invisible Grills in Bengaluru",
      "Balcony Invisible Grills",
      "Window Invisible Grills",
      "ANS Invisible Grills Bengaluru",
      "Safety Grills",
      "ANS Safety Nets",
      "Balcony Protection",
      "Modern Safety Solutions",
      "Children Safety Grills",
      "Pet Protection Grills",
      "Stainless Steel Invisible Grills",
      "Invisible Grills Installation",
      "Balcony Safety Grills in Bengaluru",
      "Home Safety Solutions",
      "High Rise Safety Grills",
      "Bengaluru Invisible Grills",
    ],
    breadcrumb: {
      "@type": "BreadcrumbList",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "Home",
          item: "https://www.anssafetynets.com",
        },
        {
          "@type": "ListItem",
          position: 2,
          name: "Invisible Grills",
          item: "https://www.anssafetynets.com/invisiblegrills",
        },
      ],
    },
    publisher: {
      "@type": "Organization",
      name: "ANS Safety Nets",
      logo: {
        "@type": "ImageObject",
        url: "https://www.anssafetynets.com/logo.png",
        width: 250,
        height: 100,
      },
      contactPoint: [
        {
          "@type": "ContactPoint",
          telephone: "+91-7416116587",
          contactType: "Customer Service",
          areaServed: "IN",
          availableLanguage: ["English", "Kannada"],
        },
      ],
      sameAs: [
        "https://www.facebook.com/profile.php?id=61572534324956",
        "https://www.instagram.com/anssafetynets_bengaluru/",
      ],
    },
    mainEntity: {
      "@type": "Organization",
      name: "ANS Safety Nets",
      address: {
        "@type": "PostalAddress",
        streetAddress:
          "74/9, 5th Cross Rd, Muthyala Nagar, Bahubali Nagar, Jalahalli, Bengaluru, Karnataka 560013",
        addressLocality: "Bengaluru",
        addressRegion: "KA",
        postalCode: "560013",
        addressCountry: "IN",
      },
      service: [
        {
          "@type": "Service",
          name: "Invisible Grills",
          areaServed: "Bengaluru",
        },
      ],
    },
  };

  return (
    <div>
      <Helmet>
        <title>Invisible Grills in Bengaluru - ANS Safety Nets</title>
        <meta
          name="description"
          content="Secure your balconies and windows with stylish Invisible Grills by ANS Safety Nets in Bengaluru. Enjoy safety with an unobstructed view and modern design."
        />
        <meta
          name="keywords"
          content="ANS Safety Nets, Invisible Grills, Invisible Grills in Bengaluru, Balcony Invisible Grills, Window Invisible Grills, Safety Grills, Modern Safety Solutions, Balcony Protection, Stainless Steel Invisible Grills, Pet Safety Grills, Balcony Safety Grills in Bengaluru"
        />
        <meta name="author" content="ANS Safety Nets, Bengaluru" />
        <link
          rel="canonical"
          href="https://www.anssafetynets.com/invisiblegrills"
        />
        <script type="application/ld+json">{JSON.stringify(schemaData)}</script>
      </Helmet>

      <HeroSection
        title="Invisible Grills"
        description="Elegant protection for your balconies and windows — safety with a clear view."
        bgColor="bg-[#2c3639]"
      />

      <ProductDetails
        title="Why Choose Our Invisible Grills?"
        content={`ANS Safety Nets brings you a modern solution for home and apartment safety — Invisible Grills. Designed with premium stainless steel cables and a sleek finish, our grills offer both safety and elegance without blocking your beautiful view.

Invisible grills are perfect for balconies, windows, and open spaces where safety and aesthetics go hand in hand. They provide strong protection against falls for children, pets, and the elderly while maintaining an open, luxurious appearance.

Our professional team ensures precise installation using high-quality tensioning systems for durability and security. These grills are rust-resistant, maintenance-free, and can withstand harsh weather — ensuring a safe and stylish home for years to come.`}
        image={main}
      />

      <Images images={[img1, img2, img3]} />

      <Benefits
        benefits={[
          {
            title: "Unobstructed View",
            description: "Enjoy your view without compromising safety.",
          },
          {
            title: "Rust & Weather Resistant",
            description: "Durable stainless steel wires withstand all weather.",
          },
          {
            title: "Child & Pet Safe",
            description: "Keeps children and pets safe from accidental falls.",
          },
        ]}
      />

      <FAQSection
        faqs={[
          {
            question:
              "Are invisible grills strong enough for high-rise buildings?",
            answer:
              "Yes, our invisible grills are made with high-tensile stainless steel wires designed to handle heavy pressure safely.",
          },
          {
            question: "Do invisible grills require maintenance?",
            answer:
              "Not really! They are rust-proof and require only minimal cleaning to maintain their shine and safety.",
          },
        ]}
      />
    </div>
  );
}
